import React from "react";

const dotStyle = (color) => ({
  display: "inline-block",
  width: 8,
  height: 8,
  borderRadius: "50%",
  background: color,
});

export const AssetConditionOption = (props) => {
  const { data, innerRef, innerProps, isFocused } = props;
  return (
    <div
      ref={innerRef}
      {...innerProps}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "8px 12px",
        cursor: "pointer",
        background: isFocused ? "#eef3ff" : "transparent",
      }}
    >
      <span style={dotStyle(data.color)} />
      <span style={{ color: "#9ca3af" }}>{data.value}</span>
      <span>{data.label}</span>
    </div>
  );
};

export const AssetConditionValue = ({ option }) => {
  if (!option) return null;
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
      <span style={dotStyle(option.color)} />
      <span style={{ color: "#9ca3af" }}>{option.value}</span>
      <span>{option.label}</span>
    </span>
  );
};
